import { Alert } from "antd";
import { useFreire } from "../../utils/freireContext";
import * as texts from "./locales";

export const FleetInstructionsAlert = () => {
  const { freire } = useFreire();

  return (
    <Alert
      message={
        <>
          <b>{freire(texts.FLEET_ALERT_ATTENTION)}</b>
          <br />
          <span>{freire(texts.FLEET_ALERT_ITEM_1)}</span>
          <br />
          <span>{freire(texts.FLEET_ALERT_ITEM_2)}</span>
          <br />
          <span>{freire(texts.FLEET_ALERT_ITEM_3)}</span>
        </>
      }
      type={"warning"}
      showIcon
    />
  );
};
